import React from "react";
import PropTypes from "prop-types";

import "./SvgLoader.less";

import loading from "./loading.svg";

const SvgLoader = ({ leftAligned, asOverlay }) => (
  <div
    role={asOverlay ? "dialog" : "presentation"}
    className={
      "SvgLoader" +
      (leftAligned ? " leftAligned" : "") +
      (asOverlay ? " asOverlay" : "")
    }
  >
    <img
      src={loading}
      alt="loading..." // TODO: Translate this at some point (not sure about priority to be honest)
    />
  </div>
);

SvgLoader.propTypes = {
  leftAligned: PropTypes.bool,
  asOverlay: PropTypes.bool,
};

export default SvgLoader;
